import axios from "./axios";

export default {
  list(page, subjectId) {
    const url = subjectId ? `/tests?page=${page}&subject_id=${subjectId}` : `/tests?page=${page}`;
    return axios.get(url);
  },
  listWhiteTests(page, subjectId) {
    const url = subjectId
      ? `/tests/whites?page=${page}&subject_id=${subjectId}`
      : `/tests/whites?page=${page}`;
    return axios.get(url);
  },
  show(testId) {
    return axios.get(`tests/${testId}`);
  },
  correction(testId) {
    return axios.get(`tests/${testId}/correction`);
  },
  subjects() {
    return axios.get("/tests/subjects");
  },
};
